module.exports = __webpack_public_path__ + "img/teilnehmer-skikurs.4888232b.svg";